const Socket = ({ fill, ...props }: React.SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 56" {...props}>
		<circle cx={28} cy={28} r={28} fill="#fff" />
		<rect width={5.6} height={14} x={15.68} y={14} fill={fill} rx={2.8} />
		<path
			fill={fill}
			d="M32.48 45.92h-8.96v-5.6a4.48 4.48 0 1 1 8.96 0v5.6Z"
		/>
		<rect width={5.6} height={14} x={34.719} y={14} fill={fill} rx={2.8} />
	</svg>
);
export default Socket;
